
  export default {
    name: 'LoadingComponent',
    props: {
      loading: {
        type: Boolean,
        default: false
      }
    }
  }
